import { requestPhoenix } from '../../network';
import { KalturaApiResponse } from '../../network/type';

export type DeletePersonalListArgs = {
  personalListId: number;
};

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/personalList/action/delete
 */
export function deletePersonalList({ personalListId }: DeletePersonalListArgs) {
  return requestPhoenix<KalturaApiResponse<never>>({
    path: '/personallist/action/delete',
    body: { personalListId },
  });
}
